function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { TiposDocStore } from 'src/_candidato/data/tiposStore';
import { keyBy } from 'lodash';
import './panel-doc-requirements.scss';
var PanelDocRequirementsComponentCtrl = /*#__PURE__*/function () {
  PanelDocRequirementsComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function PanelDocRequirementsComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelDocRequirementsComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "$ready", false);
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelDocRequirementsComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelDocRequirementsComponentCtrl] onInit');
      this._leerReglasVal();
    }
  }, {
    key: "_leerReglasVal",
    value: function _leerReglasVal() {
      var _this = this;
      this.$loading = true;
      this.AccesoDatos.Documentacion_CLIENT.reglasValidacionDocObligatoria().then(function (reglasResponse) {
        _this.estados = reglasResponse.estados;
        _this.tiposDoc = new TiposDocStore(reglasResponse.tiposdocs);
        _this.pregsStore = new PreguntasStore(reglasResponse.forms, function (idform) {
          return _this.AccesoDatos.GestionCurr_CLIENT.pregsSeleccionCurriculumsFormulario(idform);
        });
        _this.reglasVal = reglasResponse.reglasVal.map(function (r) {
          return new ReglaReqDoc(r, _this.estados, _this.tiposDoc, _this.pregsStore);
        });
        _this.$loading = false;
        _this.$timeout(function () {
          return _this.$ready = true;
        }, 100);
      });
    }
  }, {
    key: "nuevaReglaVal",
    value: function nuevaReglaVal() {
      this.reglasVal.push(new ReglaReqDoc({}, this.estados, this.tiposDoc, this.pregsStore));
    }
  }]);
}();
angular.module('candidato').component('panelDocRequirements', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelDocRequirementsComponentCtrl,
  // templateUrl: "panel-doc-requirements.component.html",
  template: require('./panel-doc-requirements.component.html')
});
export var FormsStore = /*#__PURE__*/_createClass(function FormsStore(list) {
  _classCallCheck(this, FormsStore);
  this.list = list;
  this.byId = keyBy(list, function (f) {
    return f.idform;
  });
});
export var PregsFormulario = /*#__PURE__*/_createClass(function PregsFormulario(pregs) {
  _classCallCheck(this, PregsFormulario);
  this.list = pregs.listPreguntas;
});
export var PreguntasStore = /*#__PURE__*/function () {
  function PreguntasStore(list, pregsFormSupplier) {
    _classCallCheck(this, PreguntasStore);
    _defineProperty(this, "pregsPorFormulario", {});
    this.pregsFormSupplier = pregsFormSupplier;
    this.formsStore = new FormsStore(list);
  }
  return _createClass(PreguntasStore, [{
    key: "pregsParaFormulario",
    value: function () {
      var _pregsParaFormulario = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(idform) {
        var _pregsForm, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _pregsForm = this.pregsPorFormulario[idform];
              if (_pregsForm) {
                _context.n = 2;
                break;
              }
              _t = PregsFormulario;
              _context.n = 1;
              return this.pregsFormSupplier(idform);
            case 1:
              _t2 = _context.v;
              return _context.a(2, (this.pregsPorFormulario[idform] = new _t(_t2)).list);
            case 2:
              return _context.a(2, _pregsForm.list);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function pregsParaFormulario(_x) {
        return _pregsParaFormulario.apply(this, arguments);
      }
      return pregsParaFormulario;
    }()
  }]);
}();
export var ReglaReqDoc = /*#__PURE__*/function () {
  function ReglaReqDoc(rule, estados, tiposDoc, pregsStore) {
    _classCallCheck(this, ReglaReqDoc);
    _defineProperty(this, "$dirty", false);
    this.estados = estados;
    this.tiposDoc = tiposDoc;
    this.pregsStore = pregsStore;
    this.actualiza({
      regla: rule
    });
  }
  return _createClass(ReglaReqDoc, [{
    key: "actualiza",
    value: function actualiza(_rule) {
      this.rule = _rule.regla;
      this.$dirty = !this.rule.idreqdoc;
    }
  }, {
    key: "estadosList",
    get: function get() {
      return this.estados.list;
    }
  }, {
    key: "tiposDocGruposList",
    get: function get() {
      return this.tiposDoc.gruposDocList();
    }
  }, {
    key: "formsList",
    get: function get() {
      return this.pregsStore.formsStore.list;
    }
  }]);
}();